/* eslint-disable import/order */
import '@/@iconify/icons-bundle'
import App from '@/App.vue'
import layoutsPlugin from '@/plugins/layouts'
import vuetify from '@/plugins/vuetify'
import { loadFonts } from '@/plugins/webfontloader'
import { abilitiesPlugin } from '@casl/vue'
import ability from '@/plugins/casl/ability'
import { install } from '@/plugins/pinia'
import router from '@/router'
import '@core/scss/template/index.scss'
import '@styles/styles.scss'
import { createApp } from 'vue'
import { mask } from 'vue-the-mask'
import { vue3Debounce } from 'vue-debounce'
import * as Sentry from '@sentry/vue'

loadFonts()

// Create vue app
const app = createApp(App)

// Use plugins
app.use(vuetify)
app.use(router)
install(app)
app.use(abilitiesPlugin, ability, {
  useGlobalProperties: true,
})
app.use(layoutsPlugin).directive('debounce', vue3Debounce({ lock: true }))
app.directive('mask', mask)

// Mount vue app
app.mount('#app')
